const BasePathEnum = {
  Home: "/",
  CO2: "/co2",
  Guide: "/guide",
  Templates: "/templates",
  Edit: "/edit",
  Settings: "/settings",
  Create: "/create",
  Admin: "/admin",
  Send: "/send",
  Interviewers: "/interviewers",
  EmailTemplates: "/email-templates",
  Feedback: "/feedback",
  Scheduler: "/scheduler",
  PitchPages: "/pitch-pages",
  LegacySchedulerPage: "/scheduler",
  Onboarding: "/onboarding",
  Upsell: "/upsell",
  SchedulerPage: "/s",
};

export default BasePathEnum;
